import React from 'react';
import Pantalla27 from '../Pantalla27/Pantalla27';
import Header from '../../Header/Header';
import Footer from '../../Footer/Footer';

function PantallaBase27() {
    return (
        <>
            <div className='initBack_P2 animate__animated animate__fadeIn'>

                <Header imgBackRig={true} title='Autotransporte' />

                <div className='containerRender'>

                    <Pantalla27 />

                </div>

                <Footer />

            </div>
        </>
    )
}

export default PantallaBase27
